import { createBrowserClient } from '@supabase/ssr'

// createBrowserClient (from @supabase/ssr) stores the session and PKCE code
// verifier in cookies, so the server-side /auth/callback route handler can
// read the verifier when exchanging the OAuth/magic-link code.
//
// The previous localStorage-based setup broke OAuth and magic links because
// the PKCE verifier was written to localStorage in the browser but the
// callback route handler looked for it in cookies — two different stores.
export function createClient() {
  return createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
  )
}
